import * as React from 'react';
import classnames from 'classnames';

import { AppPicture } from '@src/services/app/components/AppPicture/AppPicture';

export interface MissionProps {
  className?: string;
}

/**
 * @name Mission
 * @description Component rendering Haldi's sustainability mission.
 */
export const Mission = (props: MissionProps) => {
  const { className } = props;

  return (
    <div
      className={classnames(
        'flex flex-col bg-seaSaltLight p-6 md:gap-8 md:p-20',
        className
      )}
    >
      <div>
        <h1 className="md:text-5xl md:leading-relaxed">
          Our mission is to become the{' '}
          <span className="text-pine md:text-5xl">
            world's most sustainable beauty retailer.
          </span>
        </h1>
      </div>
      <div className="flex flex-wrap-reverse justify-center md:flex-nowrap md:items-end">
        <div className="flex flex-col justify-center p-8 pl-0">
          <AppPicture
            className="md:min-w-[290px]"
            png="/images/png/simran.png"
          />
          <div>
            <h2 className="m-0 text-right font-give-you-glory">Simran</h2>
            <p className="text-right">Founder & CEO</p>
          </div>
        </div>
        <div className="bg-white p-6 md:p-10">
          <p>
            A by-product of my humble upbringing in India, was the inherent
            minimal waste living. No jar was ever thrown as it was endlessly
            reused and every tube was squeezed till the very end.
          </p>
          <p>We didn't call it sustainability, that's just how we lived.</p>
          <p>
            At Haldi, the same philosophy is in our DNA. We want no jar to go to
            waste and every tube on your bathroom shelf to be squeeeeeeezed. So
            we build routines around what's on your bathroom shelf.
          </p>
          <p>
            The beauty industry has a lot of waste and it's beyond packaging.
            From users being in an endless cycle of trial and error and never
            reaching the bottom of a jar, to products expiring on retailers
            shelves, the waste is significant, all of which lands up in
            landfill. Yes, landfill!
          </p>
          <p>
            I invite you to join #squeezethetube to ensure every product you buy
            is right for you and your skin, and is squeezed till the end.
            Collectively we can make a significant difference.
          </p>
        </div>
      </div>
    </div>
  );
};
